export default __webpack_public_path__ + "static/media/bauhaus-sm.5c6a930c.svg";